
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49ed"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49ed"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1n03X", function(module, exports) {

$parcel$export(module.exports, "getLocalizationHtmlContent", function () { return $0ff7fceb58bca7ac$export$f2de58601cccd04c; });
$parcel$export(module.exports, "getFaqContentHtml", function () { return $0ff7fceb58bca7ac$export$22413596ff7e266a; });
$parcel$export(module.exports, "hasFaqContentHtml", function () { return $0ff7fceb58bca7ac$export$a044480ffd003c9d; });
$parcel$export(module.exports, "hasPrivacyContentHtml", function () { return $0ff7fceb58bca7ac$export$84b8cac44c1c23a5; });

var $hXoW9 = parcelRequire("hXoW9");

var $iL6st = parcelRequire("iL6st");

var $6wMuu = parcelRequire("6wMuu");
const $0ff7fceb58bca7ac$var$contentCache = new Map();
async function $0ff7fceb58bca7ac$export$f2de58601cccd04c({ contentId: contentId, ...options }) {
    const context = $0ff7fceb58bca7ac$var$resolveContext(options);
    const cacheKey = `${context.orgId || 'default'}:${context.eventCode || 'global'}:${context.language}:${contentId}`;
    const shouldUseCache = typeof options.fetcher !== 'function';
    if (shouldUseCache && $0ff7fceb58bca7ac$var$contentCache.has(cacheKey)) return $0ff7fceb58bca7ac$var$contentCache.get(cacheKey);
    const promise = context.orgId ? $0ff7fceb58bca7ac$var$ensureLocalizationManifestLoaded({
        ...options,
        ...context
    }).then(()=>(0, $iL6st.resolveLocalizationFile)({
            orgId: context.orgId,
            eventCode: context.eventCode,
            language: context.language,
            contentId: contentId
        }, {
            fetcher: options.fetcher
        })) : Promise.resolve((0, $iL6st.getSystemDefaultLocalizationFile)({
        contentId: contentId,
        language: context.language
    }));
    if (shouldUseCache) $0ff7fceb58bca7ac$var$contentCache.set(cacheKey, promise);
    return promise;
}
async function $0ff7fceb58bca7ac$export$fcf1aa683a469494({ contentId: contentId, ...options }) {
    const context = $0ff7fceb58bca7ac$var$resolveContext(options);
    if (!context.orgId) return (0, $iL6st.hasResolvedLocalizationFileContent)((0, $iL6st.getSystemDefaultLocalizationFile)({
        contentId: contentId,
        language: context.language
    }));
    await $0ff7fceb58bca7ac$var$ensureLocalizationManifestLoaded({
        ...options,
        ...context
    });
    return (0, $iL6st.hasResolvedLocalizationFile)({
        orgId: context.orgId,
        eventCode: context.eventCode,
        language: context.language,
        contentId: contentId
    }, {
        fetcher: options.fetcher
    });
}
async function $0ff7fceb58bca7ac$var$ensureLocalizationManifestLoaded(options = {}) {
    const context = $0ff7fceb58bca7ac$var$resolveContext(options);
    if (!context.orgId) return {};
    return (0, $iL6st.fetchLocalizationFilesManifest)({
        orgId: context.orgId
    }, {
        fetcher: options.fetcher
    });
}
async function $0ff7fceb58bca7ac$export$22413596ff7e266a(options) {
    return $0ff7fceb58bca7ac$export$f2de58601cccd04c({
        contentId: 'faq',
        ...options
    });
}
async function $0ff7fceb58bca7ac$export$a044480ffd003c9d(options) {
    return $0ff7fceb58bca7ac$export$fcf1aa683a469494({
        contentId: 'faq',
        ...options
    });
}
async function $0ff7fceb58bca7ac$export$2fa7b8c1bfbf825a(options) {
    return $0ff7fceb58bca7ac$export$f2de58601cccd04c({
        contentId: 'privacy',
        ...options
    });
}
async function $0ff7fceb58bca7ac$export$84b8cac44c1c23a5(options) {
    return $0ff7fceb58bca7ac$export$fcf1aa683a469494({
        contentId: 'privacy',
        ...options
    });
}
function $0ff7fceb58bca7ac$export$3177fe697303a6d5(htmlContent = '') {
    return (0, $iL6st.hasResolvedLocalizationFileContent)(htmlContent);
}
function $0ff7fceb58bca7ac$var$resolveContext(options = {}) {
    const storedContext = (0, $6wMuu.getLocalizationContext)();
    return {
        orgId: options.orgId ?? storedContext.orgId,
        eventCode: options.eventCode ?? storedContext.eventCode ?? 'global',
        language: $0ff7fceb58bca7ac$var$normalizeLanguage(options.language ?? (0, $hXoW9.getCurrentLanguage)())
    };
}
function $0ff7fceb58bca7ac$var$normalizeLanguage(language = 'en') {
    return `${language || 'en'}`.split('-')[0];
}

});
parcelRegister("iL6st", function(module, exports) {

$parcel$export(module.exports, "getSystemDefaultLocalizationFile", function () { return $da81a03ca3af5de5$export$cc52e73e52a115; });
$parcel$export(module.exports, "fetchLocalizationFilesManifest", function () { return $da81a03ca3af5de5$export$607b892a23a039a3; });
$parcel$export(module.exports, "resolveLocalizationFile", function () { return $da81a03ca3af5de5$export$c3e78633920a0f3a; });
$parcel$export(module.exports, "hasResolvedLocalizationFileContent", function () { return $da81a03ca3af5de5$export$dce6e28a00658b5e; });
$parcel$export(module.exports, "hasResolvedLocalizationFile", function () { return $da81a03ca3af5de5$export$70589e6afd8a1fdf; });
const $da81a03ca3af5de5$export$32f00d4cbf56dcce = 'file';
const $da81a03ca3af5de5$export$b260e63ac0efcf3 = 'inherit';
const $da81a03ca3af5de5$export$e933eab79fe8a405 = 'html';
const $da81a03ca3af5de5$export$b5db2b0b3350ad09 = 'json';
const $da81a03ca3af5de5$var$manifestCache = new Map();
const $da81a03ca3af5de5$var$localizationFileCache = new Map();
const $da81a03ca3af5de5$var$LOCALIZATION_FILE_DEFINITIONS = {
    faq: {
        label: 'FAQ',
        description: '',
        format: $da81a03ca3af5de5$export$e933eab79fe8a405,
        systemDefaults: {
            en: [
                '<h4>How do I get my pictures and videos?</h4>',
                '<p>We use state of the art face recognition technology that will find photos and videos we made of you and your party throughout your experience. To take advantage of this feature, you must register portrait photos (selfies) of each member of your party.</p>',
                '<h4>What does a Storibox Pass include?</h4>',
                '<p>With a Storibox Pass, you may</p>',
                '<ul><li>Download and save high-resolution images and videos, based on which package you purchased.</li><li>Instantly share your signature memories with your friends and family.</li><li>Access your content for up to 60 days post your visit.</li></ul>',
                '<h4>I have purchased a Storibox Pass. When can I begin downloading my photos?</h4>',
                '<p>With a Storibox Pass, you may begin downloading as soon as photos are available in your account. You may choose to download them immediately or after your trip, because the photos will be available for up to 60 days from the day of your visit.</p>',
                '<h4>I have not decided to get a Storibox Pass. Can I still view my images?</h4>',
                '<p>If you did not purchase a digital pass, you can still preview your images, but they will be watermarked.</p>'
            ].join(''),
            fr: [
                "<h4>Comment puis-je r\xe9cup\xe9rer mes photos et vid\xe9os ?</h4>",
                "<p>Nous utilisons une technologie de reconnaissance faciale de pointe qui retrouvera les photos et vid\xe9os prises de vous et de votre groupe tout au long de votre exp\xe9rience. Pour profiter de cette fonctionnalit\xe9, vous devez enregistrer des photos portrait (selfies) de chaque membre de votre groupe.</p>",
                '<h4>Que comprend un Pass Storibox ?</h4>',
                '<p>Avec un Pass Storibox, vous pouvez</p>',
                "<ul><li>T\xe9l\xe9charger et enregistrer des images et vid\xe9os en haute r\xe9solution, selon le forfait que vous avez achet\xe9.</li><li>Partager instantan\xe9ment vos souvenirs inoubliables avec vos proches.</li><li>Acc\xe9der \xe0 votre contenu jusqu'\xe0 60 jours apr\xe8s votre visite.</li></ul>",
                "<h4>J'ai achet\xe9 un Pass Storibox. Quand puis-je commencer \xe0 t\xe9l\xe9charger mes photos ?</h4>",
                "<p>Avec un Pass Storibox, vous pouvez commencer \xe0 t\xe9l\xe9charger d\xe8s que les photos sont disponibles dans votre compte. Vous pouvez choisir de les t\xe9l\xe9charger imm\xe9diatement ou apr\xe8s votre voyage, car elles resteront disponibles jusqu'\xe0 60 jours \xe0 compter du jour de votre visite.</p>",
                "<h4>Je n'ai pas encore d\xe9cid\xe9 de prendre un Pass Storibox. Puis-je quand m\xeame voir mes images ?</h4>",
                "<p>Si vous n'avez pas achet\xe9 de pass num\xe9rique, vous pouvez tout de m\xeame pr\xe9visualiser vos images, mais elles seront filigran\xe9es.</p>"
            ].join('')
        }
    },
    privacy: {
        label: 'Terms and Conditions',
        description: '',
        format: $da81a03ca3af5de5$export$e933eab79fe8a405,
        systemDefaults: {
            en: '',
            fr: ''
        }
    }
};
function $da81a03ca3af5de5$export$6e94e90b32c8a6d7() {
    return Object.entries($da81a03ca3af5de5$var$LOCALIZATION_FILE_DEFINITIONS).map(([contentId, definition])=>({
            contentId: contentId,
            ...definition
        }));
}
function $da81a03ca3af5de5$export$533749505d2e2dda(contentId) {
    const definition = $da81a03ca3af5de5$var$LOCALIZATION_FILE_DEFINITIONS[contentId];
    return definition ? {
        contentId: contentId,
        ...definition
    } : null;
}
function $da81a03ca3af5de5$export$cc52e73e52a115({ contentId: contentId, language: language }) {
    const normalizedLanguage = $da81a03ca3af5de5$var$normalizeLanguage(language);
    const definition = $da81a03ca3af5de5$var$LOCALIZATION_FILE_DEFINITIONS[contentId];
    if (!definition) return '';
    return definition.systemDefaults[normalizedLanguage] ?? definition.systemDefaults.en ?? '';
}
function $da81a03ca3af5de5$export$3875d426de3b5744({ orgId: orgId }) {
    return `${orgId}/localization-files/`;
}
function $da81a03ca3af5de5$export$dfc42548c64f8bbf({ orgId: orgId }) {
    return `${$da81a03ca3af5de5$export$3875d426de3b5744({
        orgId: orgId
    })}manifest.json`;
}
function $da81a03ca3af5de5$export$97a9579c8d4be886({ orgId: orgId, eventCode: eventCode = 'global', language: language }) {
    const normalizedLanguage = $da81a03ca3af5de5$var$normalizeLanguage(language);
    return `${orgId}/localization-files/${$da81a03ca3af5de5$var$getScopePath(eventCode)}/${normalizedLanguage}/`;
}
function $da81a03ca3af5de5$export$e648191fb78f5177({ orgId: orgId, eventCode: eventCode = 'global', language: language, contentId: contentId }) {
    return `${$da81a03ca3af5de5$export$97a9579c8d4be886({
        orgId: orgId,
        eventCode: eventCode,
        language: language
    })}${contentId}.${$da81a03ca3af5de5$export$b5db2b0b3350ad09}`;
}
function $da81a03ca3af5de5$export$973a9d9e2bb74575(params) {
    return `${"https://lang.occo.io"}/${$da81a03ca3af5de5$export$dfc42548c64f8bbf(params)}`;
}
function $da81a03ca3af5de5$export$9b1c244696640839(params) {
    return `${"https://lang.occo.io"}/${$da81a03ca3af5de5$export$e648191fb78f5177(params)}`;
}
async function $da81a03ca3af5de5$export$607b892a23a039a3({ orgId: orgId }, { fetcher: fetcher = globalThis.fetch, force: force = false } = {}) {
    if (typeof fetcher !== 'function') return {};
    const cacheKey = String(orgId);
    if (!force && $da81a03ca3af5de5$var$manifestCache.has(cacheKey)) return $da81a03ca3af5de5$var$manifestCache.get(cacheKey);
    const manifestPromise = (async ()=>{
        try {
            const response = await fetcher($da81a03ca3af5de5$export$973a9d9e2bb74575({
                orgId: orgId
            }), {
                method: 'GET',
                cache: 'no-cache',
                mode: 'cors'
            });
            if (!response.ok) return {};
            const data = await response.json();
            return $da81a03ca3af5de5$var$normalizeManifest(data);
        } catch (error) {
            console.error(`Error fetching localization files manifest for organisation "${orgId}":`, error);
            return {};
        }
    })();
    $da81a03ca3af5de5$var$manifestCache.set(cacheKey, manifestPromise);
    return manifestPromise;
}
async function $da81a03ca3af5de5$export$9f03077a2a4831eb({ orgId: orgId, eventCode: eventCode = 'global', language: language, contentId: contentId }, { fetcher: fetcher = globalThis.fetch, force: force = false } = {}) {
    if (typeof fetcher !== 'function') return '';
    const cacheKey = `${orgId}:${eventCode || 'global'}:${$da81a03ca3af5de5$var$normalizeLanguage(language)}:${contentId}`;
    if (!force && $da81a03ca3af5de5$var$localizationFileCache.has(cacheKey)) return $da81a03ca3af5de5$var$localizationFileCache.get(cacheKey);
    const filePromise = (async ()=>{
        try {
            const response = await fetcher($da81a03ca3af5de5$export$9b1c244696640839({
                orgId: orgId,
                eventCode: eventCode,
                language: language,
                contentId: contentId
            }), {
                method: 'GET',
                cache: 'no-cache',
                mode: 'cors'
            });
            if (!response.ok) return '';
            const rawBody = await response.text();
            return $da81a03ca3af5de5$var$parseStoredLocalizationFile(rawBody);
        } catch (error) {
            console.error(`Error fetching localization file "${contentId}":`, error);
            return '';
        }
    })();
    $da81a03ca3af5de5$var$localizationFileCache.set(cacheKey, filePromise);
    return filePromise;
}
function $da81a03ca3af5de5$export$2cd530e201b41a7c({ manifest: manifest = {}, eventCode: eventCode = 'global', contentId: contentId, language: language }) {
    const normalizedLanguage = $da81a03ca3af5de5$var$normalizeLanguage(language);
    const scopeKey = eventCode || 'global';
    return manifest?.[contentId]?.[scopeKey]?.[normalizedLanguage] || {
        source: $da81a03ca3af5de5$export$b260e63ac0efcf3,
        hasContent: false
    };
}
async function $da81a03ca3af5de5$export$c3e78633920a0f3a({ orgId: orgId, eventCode: eventCode = 'global', language: language, contentId: contentId }, { fetcher: fetcher = globalThis.fetch, force: force = false } = {}) {
    const normalizedLanguage = $da81a03ca3af5de5$var$normalizeLanguage(language);
    const resolvedEventCode = eventCode || 'global';
    const manifest = await $da81a03ca3af5de5$export$607b892a23a039a3({
        orgId: orgId
    }, {
        fetcher: fetcher,
        force: force
    });
    if (resolvedEventCode !== 'global') {
        const eventEntry = $da81a03ca3af5de5$export$2cd530e201b41a7c({
            manifest: manifest,
            eventCode: resolvedEventCode,
            contentId: contentId,
            language: normalizedLanguage
        });
        if (eventEntry.source === $da81a03ca3af5de5$export$32f00d4cbf56dcce) {
            const eventValue = await $da81a03ca3af5de5$export$9f03077a2a4831eb({
                orgId: orgId,
                eventCode: resolvedEventCode,
                language: normalizedLanguage,
                contentId: contentId
            }, {
                fetcher: fetcher,
                force: force
            });
            if ($da81a03ca3af5de5$export$dce6e28a00658b5e(eventValue)) return eventValue;
        }
    }
    const globalEntry = $da81a03ca3af5de5$export$2cd530e201b41a7c({
        manifest: manifest,
        eventCode: 'global',
        contentId: contentId,
        language: normalizedLanguage
    });
    if (globalEntry.source === $da81a03ca3af5de5$export$32f00d4cbf56dcce) {
        const globalValue = await $da81a03ca3af5de5$export$9f03077a2a4831eb({
            orgId: orgId,
            eventCode: 'global',
            language: normalizedLanguage,
            contentId: contentId
        }, {
            fetcher: fetcher,
            force: force
        });
        if ($da81a03ca3af5de5$export$dce6e28a00658b5e(globalValue)) return globalValue;
    }
    return $da81a03ca3af5de5$export$cc52e73e52a115({
        contentId: contentId,
        language: normalizedLanguage
    });
}
async function $da81a03ca3af5de5$export$70589e6afd8a1fdf(params, options) {
    const { orgId: orgId, eventCode: eventCode = 'global', language: language, contentId: contentId } = params;
    if (!orgId) return $da81a03ca3af5de5$export$dce6e28a00658b5e($da81a03ca3af5de5$export$cc52e73e52a115({
        contentId: contentId,
        language: language
    }));
    const manifest = await $da81a03ca3af5de5$export$607b892a23a039a3({
        orgId: orgId
    }, options);
    const resolvedEventCode = eventCode || 'global';
    if (resolvedEventCode !== 'global') {
        const eventEntry = $da81a03ca3af5de5$export$2cd530e201b41a7c({
            manifest: manifest,
            eventCode: resolvedEventCode,
            contentId: contentId,
            language: language
        });
        if (eventEntry.source === $da81a03ca3af5de5$export$32f00d4cbf56dcce) return eventEntry.hasContent !== false;
    }
    const globalEntry = $da81a03ca3af5de5$export$2cd530e201b41a7c({
        manifest: manifest,
        eventCode: 'global',
        contentId: contentId,
        language: language
    });
    if (globalEntry.source === $da81a03ca3af5de5$export$32f00d4cbf56dcce) return globalEntry.hasContent !== false;
    return $da81a03ca3af5de5$export$dce6e28a00658b5e($da81a03ca3af5de5$export$cc52e73e52a115({
        contentId: contentId,
        language: language
    }));
}
function $da81a03ca3af5de5$export$dce6e28a00658b5e(content = '') {
    return content.trim() !== '';
}
function $da81a03ca3af5de5$export$425930e7fea3c578({ orgId: orgId } = {}) {
    if (!orgId) {
        $da81a03ca3af5de5$var$manifestCache.clear();
        $da81a03ca3af5de5$var$localizationFileCache.clear();
        return;
    }
    const orgPrefix = `${orgId}:`;
    $da81a03ca3af5de5$var$manifestCache.delete(String(orgId));
    Array.from($da81a03ca3af5de5$var$localizationFileCache.keys()).forEach((cacheKey)=>{
        if (cacheKey.startsWith(orgPrefix)) $da81a03ca3af5de5$var$localizationFileCache.delete(cacheKey);
    });
}
function $da81a03ca3af5de5$var$getScopePath(eventCode = 'global') {
    return eventCode === 'global' ? 'global' : `events/${eventCode}`;
}
function $da81a03ca3af5de5$var$normalizeLanguage(language = 'en') {
    return `${language || 'en'}`.split('-')[0];
}
function $da81a03ca3af5de5$var$parseStoredLocalizationFile(rawBody = '') {
    if (typeof rawBody !== 'string' || rawBody.trim() === '') return '';
    try {
        const parsed = JSON.parse(rawBody);
        if (typeof parsed === 'string') return parsed;
        if (parsed && typeof parsed.content === 'string') return parsed.content;
    } catch (_error) {
        return rawBody;
    }
    return '';
}
function $da81a03ca3af5de5$var$normalizeManifest(manifest = {}) {
    if (!manifest || typeof manifest !== 'object' || Array.isArray(manifest)) return {};
    return $da81a03ca3af5de5$var$normalizeFlatManifest(manifest);
}
function $da81a03ca3af5de5$var$normalizeFlatManifest(manifest = {}) {
    const normalizedManifest = {};
    Object.entries(manifest).forEach(([contentId, scopeMap])=>{
        if (!$da81a03ca3af5de5$var$isPlainObject(scopeMap)) return;
        const normalizedScopeMap = {};
        Object.entries(scopeMap).forEach(([scopeKey, languageMap])=>{
            const normalizedLanguageMap = $da81a03ca3af5de5$var$normalizeLanguageMap(languageMap);
            if (Object.keys(normalizedLanguageMap).length > 0) normalizedScopeMap[scopeKey || 'global'] = normalizedLanguageMap;
        });
        if (Object.keys(normalizedScopeMap).length > 0) normalizedManifest[contentId] = normalizedScopeMap;
    });
    return normalizedManifest;
}
function $da81a03ca3af5de5$var$normalizeLanguageMap(languageMap = {}) {
    if (!$da81a03ca3af5de5$var$isPlainObject(languageMap)) return {};
    const normalizedLanguageMap = {};
    Object.entries(languageMap).forEach(([language, value])=>{
        if (!$da81a03ca3af5de5$var$isPlainObject(value)) return;
        normalizedLanguageMap[$da81a03ca3af5de5$var$normalizeLanguage(language)] = value;
    });
    return normalizedLanguageMap;
}
function $da81a03ca3af5de5$var$isPlainObject(value) {
    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

});



var $bTadu = parcelRequire("bTadu");

var $8xm5I = parcelRequire("8xm5I");

var $6wMuu = parcelRequire("6wMuu");

var $1n03X = parcelRequire("1n03X");

var $4iCXN = parcelRequire("4iCXN");
$17d49734b0d1dcd5$var$init();
async function $17d49734b0d1dcd5$var$init() {
    (0, $8xm5I.showLoading)();
    await (0, $6wMuu.initLoc)();
    const faqContentHtml = await (0, $1n03X.getFaqContentHtml)();
    if (!faqContentHtml.trim()) {
        window.location.href = localStorage.getItem('home') || (0, $4iCXN.pageRoutes).index;
        return;
    }
    (0, $6wMuu.setTextToElement)('.top-panel__menu-text', (0, $6wMuu.t)('title-faq'));
    const content = (0, $bTadu.makeText)('.html-content');
    (0, $bTadu.setHtml)(faqContentHtml, content);
    (0, $8xm5I.hideLoading)();
}


//# sourceMappingURL=faq.12578311.js.map
